import { Breadcrumb as BreadcrumbIO, BreadcrumbItem } from '@doda/io-react/pc';

export const Breadcrumb = () => {
  return (
    <BreadcrumbIO>
      <BreadcrumbItem href="/">転職・求人doda（デューダ）トップ</BreadcrumbItem>
      <BreadcrumbItem>希望条件にマッチした求人一覧</BreadcrumbItem>
    </BreadcrumbIO>
  );
};
